import { CircularProgress } from "@mui/material";
import React from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";

export default function Bodies({
  body,
  selectedSpecies,
  items,
  loading,
  handleChange,
  handleOriginChange,
  handleSubmit,
}) {
  return (
    <>
      <Row className="">
        <Col xs={12} xl={6}>
          <Form.Group>
            <Form.Label>Owner</Form.Label>
            <Form.Control
              type="text"
              onChange={handleChange}
              value={body.owner}
              id="owner"
              name="owner"
            />
          </Form.Group>
        </Col>
        <Col xs={12} xl={6}>
          <Form.Group>
            <Form.Label>Origin</Form.Label>
            <Form.Control
              type="text"
              onChange={handleOriginChange}
              value={body.origin}
              id="origin"
              name="origin"
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={4} xl={3} className="">
          <Form.Group>
            <Form.Label>PIC</Form.Label>
            <Form.Control
              type="text"
              onChange={handleChange}
              value={body.PIC}
              id="PIC"
              name="PIC"
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={4} xl={3}>
          <Form.Group>
            <Form.Label>Lot Size</Form.Label>
            <Form.Control
              type="number"
              onChange={handleChange}
              value={body.lot_size}
              id="lot_size"
              name="lot_size"
              min={1}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={4} xl={3}>
          <Form.Group>
            <Form.Label>Lot No</Form.Label>
            <Form.Control
              type="text"
              onChange={handleChange}
              value={body.lot_no}
              id="lot_no"
              name="lot_no"
              disabled
            />
          </Form.Group>
        </Col>
        <Col xs={0} sm={0} xl={3}></Col>
        <Col xs={12} sm={4} xl={3}>
          <Form.Group>
            <Form.Label>Body No</Form.Label>
            <Form.Control
              type="number"
              onChange={handleChange}
              value={body.body_number}
              id="body_number"
              name="body_number"
              disabled
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={4} xl={3}>
          <Form.Group>
            <Form.Label>Trend Stretch</Form.Label>
            <Form.Control
              type="number"
              min={0}
              onChange={handleChange}
              value={body.TS && body.TS}
              id="TS"
              name="TS"
              disabled={selectedSpecies !== "Bovine"}
            />
          </Form.Group>
        </Col>

        <Col xs={12} sm={4} xl={3} className="mt-sm-4 px-5 ">
          <Form.Group>
            <Form.Check
              type="switch"
              label="MSA"
              onChange={handleChange}
              checked={body.MSA}
              id="MSA"
              name="MSA"
            />
          </Form.Group>
        </Col>
        <Col xs={0} sm={12} xl={3} className="d-sm-flex justify-content-xl-end">
          <Col xs={12} sm={6} xl={6} className="pe-2">
            <Button variant="primary" className="w-100" onClick={handleSubmit}>
              Add Item
            </Button>
          </Col>
          <Col xs={12} sm={6} xl={6} className="pe-2">
            <Button variant="primary" className="w-100">
              Print
            </Button>
          </Col>
        </Col>
      </Row>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center mt-5">
          <CircularProgress variant="determinate" value={50} valueBuffer={20} />
        </div>
      ) : (
        <div
          className="table-container table-responsive"
          style={{
            maxHeight: "500px",
            overflow: "auto",
            backgroundColor: "#eee",
          }}>
          {body.production_date ? (
            items.length > 0 ? (
              <Table striped bordered hover className="">
                <thead>
                  <tr>
                    <th>Transaction Id</th>
                    <th>Body No</th>
                    <th>Lot No</th>
                    <th>Lot Size</th>
                    <th>Owner</th>
                    <th>Origin</th>
                    <th>Pic</th>
                    <th>MSA</th>
                    {selectedSpecies === "Bovine" && <th>Tender Stretch</th>}
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr>
                      <td>{item.transaction_id}</td>
                      <td>{item.body_number}</td>
                      <td>{item.lot_no}</td>
                      <td>{item.lot_size}</td>
                      <td>{item.owner}</td>
                      <td>{item.origin}</td>
                      <td>{item.PIC}</td>
                      <td>{item.MSA}</td>
                      {selectedSpecies === "Bovine" && <td>{item.TS}</td>}
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center fs-5 py-2">No Items found</div>
            )
          ) : (
            <div className="text-center fs-5 py-2">
              {" "}
              Select date to get items
            </div>
          )}
        </div>
      )}
    </>
  );
}
